import { checkPermissions } from "components/user-access";
import { useSelector } from "react-redux";

export function useUserHasAccess() {
    const actions = useSelector(state => state.loggedInUser.actions);
    return (action) => checkPermissions(action, actions);
}